import React from "react";
import EmbedPlayer from "./EmbedPlayer";
import { generateSecureUrl } from "./secure-token";

function getVideoSrc(): string | null {
  const params = new URLSearchParams(window.location.search);
  const srcParam = params.get("src");
  if (srcParam) return srcParam;
  // Se não houver src, tenta pegar o path da URL
  const path = window.location.pathname;
  // Só aceita paths que parecem válidos do CDN
  if (/^\/(movie|tv|trailers|animes|documentaries)\//.test(path)) {
    // Mantém query string se houver (token, ts, etc)
    return path + window.location.search;
  }
  return null;
}

function isFullUrl(src: string): boolean {
  return src.startsWith("http://") || src.startsWith("https://");
}

function isPlayflixCdnUrl(url: string): boolean {
  return url.startsWith("https://secure.playflix.fun/");
}

export default function App() {
  const src = getVideoSrc();
  const [videoUrl, setVideoUrl] = React.useState<string | null>(src);
  const containerRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    let cancelled = false;
    async function resolveUrl() {
      if (!src) return;
      let url = src;
      if (!isFullUrl(src)) {
        if (src.includes("token=") && src.includes("ts=")) {
          url = `https://secure.playflix.fun/${src}`;
        } else {
          // Passe a chave secreta do ambiente
          const secret = process.env.REACT_APP_SECRET_KEY_PRIMARY;
if (!secret) throw new Error('REACT_APP_SECRET_KEY_PRIMARY não definida no .env');
url = await generateSecureUrl(src.split("?")[0], secret);
        }
      } else if (isPlayflixCdnUrl(src) && !src.includes("token=") && !src.includes("ts=")) {
        const path = src.replace("https://secure.playflix.fun/", "").split("?")[0];
        // Passe a chave secreta do ambiente
        const secret = process.env.REACT_APP_SECRET_KEY_PRIMARY;
        if (!secret) throw new Error('REACT_APP_SECRET_KEY_PRIMARY não definida no .env');
        url = await generateSecureUrl(path, secret);
      }
      if (!cancelled) setVideoUrl(url);
    }
    resolveUrl();
    return () => { cancelled = true; };
  }, [src]);

  if (!src) {
    return (
      <div style={{ color: '#fff', textAlign: 'center', marginTop: 40 }}>
        <h2>Nenhum vídeo informado</h2>
        <p>Adicione <code>?src=https://secure.playflix.fun/...</code>, <code>?src=/movie/...</code> ou acesse diretamente <code>/movie/123.mp4</code> na URL.</p>
      </div>
    );
  }

  if (!videoUrl) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        backgroundColor: '#141414'
      }}>
        <div style={{ color: '#fff', textAlign: 'center' }}>Carregando vídeo...</div>
      </div>
    );
  }

  return (
    <div style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#000',
      margin: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{ 
        position: 'relative',
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100vh',
        backgroundColor: '#000',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <EmbedPlayer src={videoUrl} />
      </div>
    </div>
  );
}
